import { isExist, findCurrentComponentPathInLayoutByRectId, formatterDateHandle, fixOptName } from "utils"

export default {
  computed: {
    dataIds() {
      if (this.currentPageLayout?.options?.inDocument === "popover" && !this.curLayoutOptions.innerElement) {
        return this.currentPageLayout.options.sourceIds
      } else {
        return this.myid
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    // 当前组件所在通栏
    currentPageLayout() {
      const path = findCurrentComponentPathInLayoutByRectId(
        this.$store.state[this.request_prefix].page.pageLayoutList || [],
        this.myid.rect_id
      )[0]
      let pageLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: this.myid.container_id,
          pageLayoutId: path
        },
        "pageLayout"
      )
      return pageLayout
    },
    layoutOptions() {
      if (this.curLayoutOptions.innerElement) {
        return this.curLayoutOptions
      }
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds, "rect")?.options

      if (
        rectAttr &&
        isExist(this.dataIds.elementInAutoLayoutId) &&
        (isExist(this.dataIds.elementInLayoutId) || isExist(this.dataIds.elementInSwiperId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.dataIds,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent"
      ) {
        return {}
      }
      return rectAttr
    },
    curLayoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.myid, "rect")?.options

      if (
        rectAttr &&
        isExist(this.myid.elementInAutoLayoutId) &&
        (isExist(this.myid.elementInLayoutId) || isExist(this.myid.elementInSwiperId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.myid,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent"
      ) {
        return {}
      }
      return rectAttr
    },
    borderColorType() {
      return this.options?.borderColor?.type
    },
    setBorderColor() {
      return function (bgColor, backgroundImage) {
        const borderColor = this.options.borderColor
        if (borderColor.type === "color") return backgroundImage
        let gradientColor = ""
        
        switch (borderColor.type) {
          case "linearGradient":
            let tmp = []
            if (borderColor.data.stops && borderColor.data.stops.length > 0) {
              borderColor.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = gradientColor.length > 0 ? "," : ""
              // gradientColor += dot + "linear-gradient(" + borderColor.data.angle + "deg," + tmp.join(",") + ")"
              gradientColor += dot + this.$parseColor(borderColor)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (borderColor.data.stops && borderColor.data.stops.length > 0) {
              borderColor.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = gradientColor.length > 0 ? "," : ""
              const siteX = borderColor.data.siteX ? borderColor.data.siteX : 0
              const siteY = borderColor.data.siteY ? borderColor.data.siteY : 0
              // gradientColor +=
              //   dot + "radial-gradient(at " + siteX + "% " + siteY + "%," + radialTmp.join(",") + ")"
              gradientColor += dot + this.$parseColor(borderColor)
            }
            break
          default:
        } 
        if (backgroundImage) {
          return gradientColor ? backgroundImage + `,${gradientColor}` : backgroundImage
        } else if (bgColor) {
          return `linear-gradient(to bottom,${bgColor}, ${bgColor}),${gradientColor}`
        } else return backgroundImage
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.updateDataFun)
    if (this.myid && this.currentPageLayout?.options?.inDocument === "popover" && !this.curLayoutOptions.innerElement) {
      this.$eventBus.$on("update-popover-inner-data", this.popoverUpdater)
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("update-popover-inner-data", this.popoverUpdater)
    window.removeEventListener("message", this.updateDataFun)
  },
  methods: {
    popoverUpdater(target) {
      if (this.currentPageLayout.options.source_id === target.popoverPath) {
        console.log("update-popover-inner-data", this.options.innerElement, this.options.filedMapping)
        if (this.options.filedMapping) {
          const { value, dataType, isDate, dateStyle, dateTitle } = this.options.filedMapping
          if (value !== undefined && value !== "") {
            let { key, value: dataValue } = target.data[value]
            if (value === "viewNum") {
              key = "浏览量"
              dataValue = target.data[value]
            }
            if (this.options.videoObjectId) {
              dataValue = target.data.objectId
            } else if (isDate) {
              dataValue = formatterDateHandle(dataValue, dateStyle, dateTitle, key)
            } else if (dataType === "dataKey") {
              dataValue = key + "：" + dataValue
            } else if (dataType === "dataName") {
              dataValue = key
            }
            const option_name = fixOptName([this.options.innerElement])
            this.$changeOptionsEV(dataValue, option_name, false, null, this.myid, true)
          }
        }
      }
    },
    /* 后台监听更新 大屏数据 */
    updateDataFun({ data }) {
      if (this.isBigScreenPreview() && data.type === "pageInIframeUpdateData") {
        if (this.options?.innerElement) {
          switch (this.options.innerElement) {
            case "cxDate":
              if (this.date) {
                this.getValue()
                this.countTimer()
              }
              break
            case "cxWeather":
              this.getWeatherData(true)
              break
            default:
              if (this.options.appId && typeof this.updateData === "function") {
                this.updateData()
              }
          }
        } else if (this.$refs?.dmContainer) {
          // 滚动词云
          this.init()
        }
      }
    },
    getClassifyData() {
      const datas = this.shareDataPool.getData(
        `layoutRestClassify-${this.ids.container_id}-${this.ids.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`
      )
      if (datas) return JSON.parse(datas)
      return []
    },
    isGradientBorder(borderColor, themeColor) {
      let isThemeColor = false
      if (borderColor && borderColor.hasOwnProperty("isThemeColor")) isThemeColor = borderColor.isThemeColor
      else if (typeof borderColor === 'string') isThemeColor = themeColor
      return borderColor && borderColor.type !== "color" && !isThemeColor
    },
  }
}
